import { createSlice } from "@reduxjs/toolkit";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";
import { languageApi } from "src/services/Base/LanguageApi";
import { parametersApi } from "src/services/Base/ParametersApi";
import { IParametersKeyValue } from "./ParametersSlice";


interface IParametersState {
  data: Array<IParametersKeyValue>
}

const ParameterIdSlice = createSlice<IParametersState, MapReducerPayloads<IParametersState, {
  setState: IParametersState
}>>({
  name: 'ParameterIdSlice',
  initialState: {
    data: []
  },
  reducers: {
    setState: (state, action) => action.payload
  },
  extraReducers: (builder) => {
    builder.addMatcher(parametersApi.endpoints.getAllParameters.matchFulfilled, (state, action) => {
      return {
        ...state,
        data: action.payload.map(pay => {
          return {
            id: pay.id,
            aktif: pay.aktif,
            grupId: pay.grupId,
            key: pay.id,
            value: pay.adi,
            siraNo: pay.sirano,
            alan01: pay.alan01
          }
        })
      }
    })
    builder.addMatcher(languageApi.endpoints.getLanguageByNamespace.matchFulfilled, (state, action) => {
      return {
        data: state.data.map(m => {
          let val = m.value;
          let filter = action.payload.find(f => f.label === m.grupId + "|" + m.key);
          if (filter)
            val = filter.degerKarsiligi ? filter.degerKarsiligi : filter.deger
          return {
            ...m,
            value: val
          }
        })
      }
    })
  }
})
export default ParameterIdSlice;